/* eslint-disable import/no-anonymous-default-export */
export default [
    {
      "id":"0",
      "name": "Vanilla Bean",
      "desc": "A timeless classic with real vanilla bean specks.",
      "img": "service2.jpg",
      "price": "3.12",
      "order":`${Math.floor((Math.random() * 5000))}`,
      "rate":`${Math.floor((Math.random() * 5)+1)}`
    },
    {
      "id":"1",
      "name": "Strawberry Swirl",
      "desc": "Fresh strawberry puree mixed with creamy vanilla.",
      "img": "service1.jpg",
      "price": "4.50",
      "order":`${Math.floor((Math.random() * 5000))}`,
      "rate":`${Math.floor((Math.random() * 5)+1)}`
    },
    {
      "id":"2",
      "name": "Chocolate Fudge",
      "desc": "Rich and creamy chocolate with chunks of fudge.",
      "img": "service3.jpg",
      "price": "4.85",
      "order":`${Math.floor((Math.random() * 5000))}`,
      "rate":`${Math.floor((Math.random() * 5)+1)}`
    },
    {
      "id":"3",
      "name": "Mango Tango",
      "desc": "Sweet and tangy mango ice cream with a tropical twist.",
      "img": "service4.jpg",
      "price": "3.12",
      "order":`${Math.floor((Math.random() * 5000))}`,
      "rate":`${Math.floor((Math.random() * 5)+1)}`
    },
    {
      "id":"4",
      "name": "Mint Chocolate Chip",
      "desc": "Cool mint ice cream with crunchy chocolate chips.",
      "img": "service5.jpg",
      "price": "1.87",
      "order":`${Math.floor((Math.random() * 5000))}`,
      "rate":`${Math.floor((Math.random() * 5)+1)}`
    },
    {
      "id":"5",
      "name": "Raspberry Ripple",
      "desc": "Creamy ice cream swirled with tart raspberry sauce.",
      "img": "service6.jpg",
      "price": "3.90",
      "order":`${Math.floor((Math.random() * 5000))}`,
      "rate":`${Math.floor((Math.random() * 5)+1)}`
    },
    {
      "id":"6",
      "name": "Salted Caramel",
      "desc": "Sweet caramel with a hint of salt for a perfect balance.",
      "img": "service7.jpg",
      "price": "4.85",
      "order":`${Math.floor((Math.random() * 5000))}`,
      "rate":`${Math.floor((Math.random() * 5)+1)}`
    },
  ];
  